import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  filter: {
    minWidth: pxToRem(300),
    maxWidth: pxToRem(300),
    marginBottom: pxToRem(32),
  },
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  pagination: {
    marginLeft: 0,
  },
  search: {
    marginBottom: pxToRem(32),
    maxWidth: pxToRem(320),
    width: pxToRem(312),
    selectors: {
      '&::before': {
        content: '" "',
        position: 'absolute',
        height: '70%',
        width: pxToRem(1),
        top: '15%',
        left: '-1px',
        backgroundColor: theme.palette.neutralQuaternary,
      },
    },
  },
  resultsMessage: {
    marginBottom: pxToRem(10),
  },
  noResultsSentence: {
    marginTop: pxToRem(5),
    fontWeight: 400,
  },
  partnerResultsMessage: {
    fontSize: `${pxToRem(12)} !important`,
    fontWeight: '400 !important',
  },
  userList: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        maxHeight: pxToRem(460),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  },
  filterAndSearchContainer: {
    display: 'flex',
    marginTop: '15px',
    maxWidth: pxToRem(510),
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  searchFilter: {
    maxWidth: pxToRem(223),
    width: pxToRem(195),
    selectors: {
      '& span': {
        borderWidth: 0,
        borderRadius: 0,
        borderBottomColor: theme.palette.themePrimary,
        borderBottomWidth: pxToRem(1),
        fontWeight: 'normal',
      },
    },
  },
});
